export function humanizeSlug(slug = '') {
  return slug
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function contactHref(service?: string) {
  return service ? `/contact?service=${encodeURIComponent(service)}` : '/contact';
}
